<div class="restrictionCard">
  <div class="info">
    <h2 class="restrictionCard-title1 text-black line-bottom">
      معلومات الالغاء
    </h2>
    <div class="restrictionCard-label text-grey">أسباب الالغاء</div>
    <div class="restrictionCard-title1 text-black">
      {{ franchiseSuspension?.reason ?? franchise.cancellationReason }}
    </div>

    <div class="restrictionCard-label text-grey">المرفقات</div>
    <div *ngIf="!this.cancelAttachment">لا توجد مرفقات</div>
    <div class="row" *ngIf="this.cancelAttachment">
      <div class="col-lg-4 col-6">
        <div class="file-container">
          <div class="file-container-info d-flex">
            <div class="file-icon">
              <img src="./assets/images/pdf-icon.svg" />
            </div>
            <div [qcId]="'attachment-div'" class="file-info">
              <h6 class="file-name">{{ cancelAttachment.fileName }}</h6>
              <h6 class="file-type">
                {{ cancelAttachment.attachmentTypeName }}
              </h6>
            </div>
          </div>
          <div class="icons">
            <div
              class="icon d-flex justify-content-center align-items-center preview"
            >
              <i class="fa-light fa-eye cursor-pointer"></i>
            </div>
            <div
              class="icon d-flex justify-content-center align-items-center download"
              (click)="
                downloadAttachment(
                  cancelAttachment.publicId,
                  cancelAttachment.fileName
                )
              "
            >
              <i
                class="fa-sharp fa-regular fa-arrow-down-to-line cursor-pointer"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <h2 class="restrictionCard-label text-grey mb-1">حالة القيد</h2>
        <div class="restrictionCard-title1 text-black">
          <span [qcId]="'suspended-status-span'" class="badge cancelled"
            >ملغي</span
          >
        </div>
      </div>
      <div class="col-md-4" *ngIf="franchiseSuspension?.employeeName">
        <h2 class="restrictionCard-label text-grey mb-1">اسم الموظف</h2>
        <div class="restrictionCard-title1 text-black">
          {{ franchiseSuspension?.employeeName }}
        </div>
      </div>
      <div class="col-md-4">
        <h2 class="restrictionCard-label text-grey mb-1">تاريخ الالغاء</h2>
        <div class="restrictionCard-title1 text-black">
          {{
            franchiseSuspension?.createdDatetime ?? franchise.cancellationDate
          }}
        </div>
      </div>
    </div>
    <hr class="border-line" />
  </div>
</div>
